import { render, staticRenderFns } from "./ModalSans.vue?vue&type=template&id=214a0463&"
import script from "./ModalSans.vue?vue&type=script&lang=js&"
export * from "./ModalSans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports